export default __webpack_public_path__ + "static/media/blog3.62ef4ded.jpg";